import * as React from 'react';
import { Button, Card, Col, Form, Row, Table } from 'react-bootstrap';
import {
    FaCheck,
    FaCheckCircle,
    FaClock,
    FaFileAlt,
    FaTimes,
    FaTimesCircle,
    FaShare
} from 'react-icons/fa';
import { Redirect } from 'react-router';
import {
    CardBody,
    Container,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap';
import QueryString from 'query-string';

import * as ModelApproveRejectWorkflow from '../../../models/workflow/ApproveRejectWorkflow';
import * as ModelSearchWorkflowInbox from '../../../models/workflow/SearchWorkflowInbox';
import {
    formatDMY,
    formatYMDToDMY,
    numberWithCommas
} from '../../../modules/Common';
import ApprovalInChargeStepper from 'common/components/ApprovalInChargeStepper';
import { safeParseJson } from 'helpers/utils';
import { buildAttachmentDisplayList } from 'helpers/attachmentUtils';
import { NewLineText } from '../../../helpers/NewLineText';
import SignInComponent from '../../../components/auth/SignInComponent';

import useViewerViewModel, {
    isDMSFile,
    ViewerProps
} from './WorkflowInboxInformationViewerFn.viewmodel';

function WorkflowInboxInformationViewerFn(props: ViewerProps) {
    const {
        userId,
        srcHistory,
        srcLogin,
        loginModal,
        controlRedirect,
        locationSearch,
        workflowValueUse,
        formData,
        checkresponse,
        messageModal,
        message,
        modeApproveReject,
        successModal,
        successModalHeader,
        src,
        fileName,
        selectedFilePath,
        displayApproveInChargeMode,
        setDisplayApproveInChargeMode,
        isLoadApproveReject,
        statusResponseApproveReject,
        responseApproveReject,
        blindLogin,
        onchangeMessage,
        onsuccessApproveReject,
        handleApprove,
        handleReject,
        handleClickFileShowIframe,
        handleClickFileShowFile,
        handleCloseFile,
        handleMessage,
        handleSuccessModal,
        handleLoginModal
    } = useViewerViewModel(props);

    // ── Early redirects ───────────────────────────────────────────────────────
    if (controlRedirect) {
        console.log(props.workflowValue);
        const query = QueryString.parse(locationSearch) as Record<
            string,
            string
        >;
        if (props.workflowValue?.refId) {
            console.log('เข้าตรงนี้จ้าา อันที่2');
            console.log(props.workflowValue?.refId);
            return (
                <Redirect
                    to={
                        '/workflow-report-detail?ref_id=' +
                        props.workflowValue.refId
                    }
                />
            );
        }
        if (query.ref_id) {
            console.log('เข้าตรงนี้จ้าา');
            console.log(query.ref_id);

            return (
                <Redirect
                    to={'/workflow-inbox-overview?ref_id=' + query.ref_id}
                />
            );
        }
    }

    if (loginModal) {
        return (
            <Redirect
                to={{ pathname: '/auth/signin', state: { from: srcHistory } }}
            />
        );
    }

    // ── Derived rendering values ──────────────────────────────────────────────
    const listDMS = safeParseJson<ModelSearchWorkflowInbox.File[]>(
        formData['listDMS']
    );
    const listFileUrl = safeParseJson<ModelSearchWorkflowInbox.FileUrl[]>(
        formData['listFileUrl']
    );
    const fileList = [...(listDMS ?? []), ...(listFileUrl ?? [])].filter(
        (file?: object) => file && Object.keys(file).length > 0
    );
    const hasSrc = src !== undefined;

    // ── Attachment list ───────────────────────────────────────────────────────
    const attachmentListJSX =
        fileList.length === 0 ? (
            <p className="text-muted mb-0">
                ผู้ขออนุมัติยืนยันส่ง Workflow โดยไม่มีไฟล์แนบ
            </p>
        ) : (
            <table>
                <tbody>
                    {buildAttachmentDisplayList(fileList).map(
                        ({ file, displayName, rowKey }) => {
                            const fName = file.file_name;
                            const filePath = isDMSFile(file)
                                ? file.file_path
                                : (file as ModelSearchWorkflowInbox.FileUrl)
                                      .url;
                            return file &&
                                (fName != null || filePath != null) ? (
                                <tr key={rowKey}>
                                    <td>
                                        <a
                                            href="javascript:void(0);"
                                            data-filename={fName}
                                            data-filepath={filePath}
                                            onClick={e =>
                                                handleClickFileShowFile(
                                                    e,
                                                    fName,
                                                    filePath,
                                                    !isDMSFile(file) && 's3'
                                                )
                                            }
                                        >
                                            <FaShare
                                                style={{
                                                    transform: 'rotate(270deg)',
                                                    color: 'green'
                                                }}
                                            />
                                        </a>
                                        &nbsp;
                                    </td>
                                    <td>
                                        <a
                                            href="javascript:void(0);"
                                            data-filename={fName}
                                            data-filepath={filePath}
                                            onClick={e =>
                                                handleClickFileShowIframe(
                                                    e,
                                                    displayName,
                                                    !isDMSFile(file) && 's3',
                                                    filePath
                                                )
                                            }
                                            style={{
                                                fontWeight:
                                                    selectedFilePath ===
                                                    filePath
                                                        ? 'bold'
                                                        : 'normal'
                                            }}
                                        >
                                            <FaFileAlt />
                                            &nbsp;{displayName}
                                        </a>
                                    </td>
                                </tr>
                            ) : null;
                        }
                    )}
                </tbody>
            </table>
        );

    // ── Approver table ────────────────────────────────────────────────────────
    const approverTableJSX = (
        <>
            {displayApproveInChargeMode === 'step' ? (
                <ApprovalInChargeStepper
                    document={
                        formData as unknown as ModelSearchWorkflowInbox.ResponseWorkflowInboxValue
                    }
                />
            ) : (
                <Table
                    responsive
                    hover
                    size="lg"
                    className="table-bordered mt-2"
                >
                    <thead>
                        <tr className="table-active text-center">
                            <th style={{ width: '2%' }}></th>
                            <th style={{ width: '20%' }}>Approver Code</th>
                            <th style={{ width: '20%' }}>Approver Name</th>
                            <th style={{ width: '10%' }}>สถานะ</th>
                            <th style={{ width: '28%' }}>Description</th>
                            <th style={{ width: '25%' }}>Approve Date/Time</th>
                        </tr>
                    </thead>
                    {!checkresponse &&
                        formData['listApprovalDetail']?.map(
                            (
                                item: ModelSearchWorkflowInbox.WorkflowInboxValue,
                                idx: number
                            ) => (
                                <tbody key={idx}>
                                    <tr
                                        key={'1-' + idx}
                                        style={
                                            item.status === 'APPROVED'
                                                ? { backgroundColor: '#90be6d' }
                                                : item.status === 'CANCEL'
                                                ? { backgroundColor: '#e5383b' }
                                                : { backgroundColor: '#f8f9fa' }
                                        }
                                    >
                                        <td>{idx + 1}</td>
                                        <td>{item.positiongroupname}</td>
                                        <td>
                                            {item.status === 'APPROVED' ||
                                            item.status === 'CANCEL'
                                                ? item.updated_byname
                                                : ''}
                                        </td>
                                        <td className="text-center">
                                            {item.status === 'APPROVED' ? (
                                                <FaCheck />
                                            ) : item.status === 'CANCEL' ? (
                                                <FaTimes />
                                            ) : (
                                                <FaClock />
                                            )}
                                        </td>
                                        <td>
                                            {item.status === 'APPROVED' ||
                                            item.status === 'CANCEL'
                                                ? item.reason
                                                : ''}
                                        </td>
                                        <td>
                                            {item.status === 'APPROVED' ||
                                            item.status === 'CANCEL'
                                                ? formatDMY(
                                                      String(
                                                          item.updatedOnFormatDateTime
                                                      )
                                                  )
                                                : ''}
                                        </td>
                                    </tr>
                                    <tr key={'2-' + idx}>
                                        <td></td>
                                        <td colSpan={5}>
                                            <table
                                                style={{ width: '100%' }}
                                                className="table-borderless"
                                            >
                                                {!checkresponse &&
                                                    formData[
                                                        'listApprovalDetail'
                                                    ][idx][
                                                        'listEmployeeInPositionGroup'
                                                    ]?.map(
                                                        (
                                                            subitem: ModelSearchWorkflowInbox.listEmployeeInPositionGroup,
                                                            subidx: number
                                                        ) => (
                                                            <tbody key={subidx}>
                                                                <tr
                                                                    key={subidx}
                                                                >
                                                                    <td
                                                                        style={{
                                                                            width: '20%'
                                                                        }}
                                                                    >
                                                                        {
                                                                            subitem.empid
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            width: '20%'
                                                                        }}
                                                                    >
                                                                        {
                                                                            subitem.empname
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        className="text-center"
                                                                        style={{
                                                                            width: '10%'
                                                                        }}
                                                                    ></td>
                                                                    <td
                                                                        style={{
                                                                            width: '30%'
                                                                        }}
                                                                    ></td>
                                                                    <td
                                                                        style={{
                                                                            width: '25%'
                                                                        }}
                                                                    ></td>
                                                                </tr>
                                                            </tbody>
                                                        )
                                                    )}
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            )
                        )}
                </Table>
            )}
        </>
    );

    // ── Form fields card ──────────────────────────────────────────────────────
    const formFieldsJSX = (
        <Card>
            <Card.Body>
                <table className="w-full text-left">
                    <tbody>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%', verticalAlign: 'top' }}
                            >
                                <label>
                                    <b>Subject :</b>
                                </label>
                            </td>
                            <td>{formData['subject']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Document Type :</b>
                                </label>
                            </td>
                            <td>{formData['docType']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Document No. :</b>
                                </label>
                            </td>
                            <td>{formData['docNo']}</td>
                        </tr>
                        {formData['refDoc'] && (
                            <tr>
                                <td
                                    className="whitespace-nowrap"
                                    style={{ width: '20%' }}
                                >
                                    <label>
                                        <b>Document Reference :</b>
                                    </label>
                                </td>
                                <td>{formData['refDoc']}</td>
                            </tr>
                        )}
                        {formData['projectName'] && (
                            <tr>
                                <td
                                    className="whitespace-nowrap"
                                    style={{ width: '20%' }}
                                >
                                    <label>
                                        <b>Project Name :</b>
                                    </label>
                                </td>
                                <td>
                                    {NewLineText(
                                        formData['projectName'],
                                        '<br/>'
                                    )}
                                </td>
                            </tr>
                        )}
                        {formData['jobName'] && (
                            <tr>
                                <td
                                    className="whitespace-nowrap"
                                    style={{ width: '20%' }}
                                >
                                    <label>
                                        <b>Job Name :</b>
                                    </label>
                                </td>
                                <td>{formData['jobName']}</td>
                            </tr>
                        )}
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Year :</b>
                                </label>
                            </td>
                            <td>{formData['docYear']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Document Date :</b>
                                </label>
                            </td>
                            <td>
                                {!checkresponse
                                    ? formatYMDToDMY(
                                          String(formData['docDate'])
                                      )
                                    : ''}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Bussiness Partner :</b>
                                </label>
                            </td>
                            <td>{formData['bussinessPartner']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Vendor Landed Cost in PO :</b>
                                </label>
                            </td>
                            <td>{formData['vendorLandedcost']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Source System Information :</b>
                                </label>
                            </td>
                            <td>
                                <a
                                    href={formData['refUrl']}
                                    target="_blank"
                                    className="cursor-pointer text-[#0366d6]"
                                >
                                    {formData['refUrl']
                                        ? 'กดที่นี่ เพื่อพาคุณไปดูข้อมูลบนระบบ'
                                        : ''}
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Requestor :</b>
                                </label>
                            </td>
                            <td>{formData['requestorName']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Requestor Amount :</b>
                                </label>
                            </td>
                            <td>
                                {numberWithCommas(formData['docAmount'])}
                                &nbsp;{formData['docCurrency']}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Current approval :</b>
                                </label>
                            </td>
                            <td>
                                {formData['curtaskid'] +
                                    '/' +
                                    formData['maxtaskid']}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%', verticalAlign: 'top' }}
                            >
                                <label>
                                    <b>Message from requested :</b>
                                </label>
                            </td>
                            <td style={{ whiteSpace: 'pre-line' }}>
                                {formData['requestorMessage']}
                            </td>
                        </tr>
                        <tr>
                            {fileList.length === 0 ? (
                                <td className="whitespace-nowrap">
                                    <label>
                                        <b>
                                            ผู้ขออนุมัติยืนยันส่ง Workflow
                                            โดยไม่มีไฟล์แนบ
                                        </b>
                                    </label>
                                </td>
                            ) : (
                                <>
                                    <td
                                        className="whitespace-nowrap"
                                        style={{ width: '20%' }}
                                    >
                                        <label>
                                            <b>Document Attachment :</b>
                                        </label>
                                    </td>
                                    <td>{attachmentListJSX}</td>
                                </>
                            )}
                        </tr>
                    </tbody>
                </table>
            </Card.Body>
        </Card>
    );

    // ── Main render ───────────────────────────────────────────────────────────
    return (
        <Container
            fluid={true}
            className="mt-3"
        >
            {/* Approve / Reject buttons */}
            <Row>
                <Col>
                    <Button
                        variant="outline-success mx-1"
                        size="sm"
                        onClick={() =>
                            handleApprove(
                                workflowValueUse.wfInstanceNo,
                                workflowValueUse.docNo,
                                workflowValueUse.userId,
                                formData['wfType'],
                                workflowValueUse.appId ?? ''
                            )
                        }
                    >
                        <FaCheck />
                        &nbsp;Approve
                    </Button>
                    <Button
                        variant="outline-danger mx-1"
                        size="sm"
                        onClick={() =>
                            handleReject(
                                workflowValueUse.wfInstanceNo,
                                workflowValueUse.docNo,
                                workflowValueUse.userId,
                                formData['wfType'],
                                workflowValueUse.appId ?? ''
                            )
                        }
                    >
                        <FaTimesCircle />
                        &nbsp;Reject
                    </Button>
                </Col>
            </Row>

            {hasSrc ? (
                /* ── SPLIT LAYOUT: info and file preview side-by-side ── */
                <Row
                    className="mt-3"
                    style={{ minHeight: '80vh' }}
                >
                    {/* LEFT: PDF viewer */}
                    <Col
                        lg={6}
                        style={{
                            borderRight: '1px solid #dee2e6',
                            overflowY: 'auto',
                            maxHeight: '80vh',
                            paddingRight: '12px'
                        }}
                    >
                        <Card>
                            <Card.Header>
                                <span
                                    className="text-truncate"
                                    style={{
                                        maxWidth: '80%',
                                        display: 'inline-block'
                                    }}
                                >
                                    {fileName}
                                </span>
                                <span style={{ float: 'right' }}>
                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={handleCloseFile}
                                    >
                                        <FaTimes
                                            size={15}
                                            color="red"
                                        />
                                        &nbsp;ปิด
                                    </Button>
                                </span>
                            </Card.Header>
                            <Card.Body style={{ padding: 0 }}>
                                <iframe
                                    src={`${src}#navpanes=0`}
                                    style={{
                                        minHeight: '900px',
                                        display: 'block',
                                        border: 'none'
                                    }}
                                    height="100%"
                                    width="100%"
                                    frameBorder="0"
                                    title="PDF Preview"
                                />
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* RIGHT: form fields (includes Document Attachment) */}
                    <Col
                        lg={6}
                        style={{
                            overflowY: 'auto',
                            maxHeight: '80vh',
                            paddingLeft: '12px'
                        }}
                    >
                        {formFieldsJSX}
                    </Col>
                </Row>
            ) : (
                /* ── NORMAL LAYOUT (no file selected) ── */
                <Row className="mt-3">
                    <Col>{formFieldsJSX}</Col>
                </Row>
            )}

            {/* ── Approver table always at the bottom ── */}
            <Row className="mt-3">
                <Col>{approverTableJSX}</Col>
            </Row>

            {/* ── Message / confirm modal ── */}
            <Modal
                isOpen={messageModal}
                toggle={handleMessage}
                size="lg"
                backdrop="static"
                keyboard={false}
            >
                <ModalHeader toggle={handleMessage}>Message</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Form.Group controlId="viewerFnMessageTextarea">
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    onChange={onchangeMessage}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="bg-[#17a2b8]"
                        variant="info"
                        onClick={onsuccessApproveReject}
                    >
                        Confirm
                    </Button>
                    <Button
                        className="bg-[#6c757d]"
                        variant="secondary"
                        onClick={handleMessage}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            {/* ── Success / approve-reject result modal ── */}
            <Modal
                isOpen={successModal}
                toggle={handleSuccessModal}
                size="lg"
                backdrop="static"
                keyboard={false}
            >
                {isLoadApproveReject &&
                    statusResponseApproveReject === 200 &&
                    responseApproveReject != null &&
                    Array.isArray(responseApproveReject['result_list']) &&
                    responseApproveReject['result_list'].map(
                        (
                            item: ModelApproveRejectWorkflow.ApproveRejectWorkflowResponse,
                            idx: number
                        ) => {
                            if (
                                item.status === 'wait_otp' ||
                                item.status === 'wait_sign'
                            ) {
                                window.location.replace(item.redirectLink);
                                return null;
                            }
                            return (
                                <React.Fragment key={idx}>
                                    <ModalHeader toggle={handleSuccessModal}>
                                        {successModalHeader}
                                    </ModalHeader>
                                    <ModalBody scrollable>
                                        <Row>
                                            <Col>
                                                <Card className="mb-1 rounded bg-white p-1 shadow-sm">
                                                    <CardBody>
                                                        <Row>
                                                            <Col
                                                                lg={2}
                                                                className="text-center"
                                                            >
                                                                {item.status ===
                                                                'SUCCESS' ? (
                                                                    <FaCheckCircle
                                                                        size={
                                                                            50
                                                                        }
                                                                        color="green"
                                                                    />
                                                                ) : (
                                                                    <FaTimesCircle
                                                                        size={
                                                                            80
                                                                        }
                                                                        color="red"
                                                                        style={{
                                                                            paddingTop:
                                                                                '30px'
                                                                        }}
                                                                    />
                                                                )}
                                                            </Col>
                                                            <Col lg={10}>
                                                                <Table
                                                                    className="table-borderless table-hover table"
                                                                    size="sm"
                                                                >
                                                                    <tr className="require-field">
                                                                        <td
                                                                            className="font-weight-bold"
                                                                            style={{
                                                                                width: '30%'
                                                                            }}
                                                                        >
                                                                            Document
                                                                            NO.
                                                                            :
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                width: '70%'
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.docNo
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="require-field">
                                                                        <td
                                                                            className="font-weight-bold"
                                                                            style={{
                                                                                width: '30%'
                                                                            }}
                                                                        >
                                                                            Status
                                                                            :
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                width: '70%'
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.status
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="require-field">
                                                                        <td
                                                                            className="font-weight-bold"
                                                                            style={{
                                                                                width: '30%'
                                                                            }}
                                                                        >
                                                                            Message
                                                                            :
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                width: '70%'
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.message
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                    {item.status ===
                                                                        'error' && (
                                                                        <tr className="require-field">
                                                                            <td
                                                                                className="font-weight-bold"
                                                                                style={{
                                                                                    width: '30%'
                                                                                }}
                                                                            >
                                                                                Error
                                                                                Message
                                                                                :
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    width: '70%'
                                                                                }}
                                                                            >
                                                                                {
                                                                                    item.errorMessage
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </Table>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button
                                            className="bg-[#dc3545]"
                                            variant="danger"
                                            onClick={handleSuccessModal}
                                            disabled={
                                                item.status === 'wait_otp'
                                            }
                                        >
                                            Close
                                        </Button>
                                    </ModalFooter>
                                </React.Fragment>
                            );
                        }
                    )}
            </Modal>

            {/* ── Login modal (rendered but superseded by Redirect early-return) ── */}
            <Modal
                isOpen={loginModal}
                toggle={handleLoginModal}
                size="xl"
                backdrop="static"
                keyboard={false}
            >
                <ModalBody>
                    <SignInComponent
                        AnonymousMode={loginModal}
                        blindLogin={blindLogin}
                    />
                    <iframe
                        style={{
                            WebkitWritingMode: 'vertical-lr',
                            overflow: 'none'
                        }}
                        src={srcLogin}
                        name="myIframe"
                        height="70%"
                        width="100%"
                        title="Iframe Example"
                        frameBorder="0"
                    />
                </ModalBody>
            </Modal>
        </Container>
    );
}

export default WorkflowInboxInformationViewerFn;
